import { Clickable, Col, Icon, Text } from 'components';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableComponents } from 'screens/Admin/components';

const TierAssignmentsListItem = memo(({ item, dataId }) => {
  const isSelected = dataId === item._id,
    { name, playerInfo, sport, tier } = item,
    { t } = useTranslation();

  return (
    <TableComponents.Tr>
      <TableComponents.Td isSelected={isSelected} first>
        <Text wid="200px">{name}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex marg="0 0 0 -10px">
          <Text wid="200px">{playerInfo && playerInfo.teamName}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text wid="200px">{sport && t(`sports.${sport}`)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text wid="200px">
            {tier && tier.shoutoutFromAthlete && tier.shoutoutFromAthlete.name}
          </Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col float="right" noFlex>
          <Clickable onClick={() => {}}>
            <Icon pad="0 24px 0 0" type="menu" dimensions={12} />
          </Clickable>
        </Col>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default TierAssignmentsListItem;
